var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVisibility48Filled = function SvgIconVisibility48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.3a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.47 22.88c-1-2.36-5.09-10.08-15.47-10.08-8.25 0-13.4 5.21-15.47 10.08-.31.72-.31 1.52 0 2.25C10.6 30 15.75 35.21 24 35.21c10.39 0 14.47-7.71 15.47-10.08.3-.72.3-1.52 0-2.24v-.01ZM17.3 24c0-3.69 3.01-6.7 6.7-6.7 3.69 0 6.7 3.01 6.7 6.7 0 3.69-3.01 6.7-6.7 6.7-3.69 0-6.7-3.01-6.7-6.7Z",
    fill: "current"
  })));
};
export default SvgIconVisibility48Filled;